/*
 * GST, the same arithmetic the server does.
 *
 * Duplicated here on purpose rather than fetched. The checkout has to show a total the
 * moment a plan is chosen, and a round trip to be told 18% of a number we already hold
 * would be a spinner where a figure should be. Both sides round the same way, so the
 * amount printed on the button is the amount Razorpay is asked to collect.
 *
 * Keep in step with utils/gst.js on the server. If they ever disagree, the server wins -
 * it is the one talking to the gateway - and the customer sees a price that is not the
 * one they are charged, which is the whole thing this screen exists to prevent.
 */
export const GST_RATE = 0.18;

export function withGst(base, rate = GST_RATE) {
    const amount = Number(base) || 0;
    const gst = Math.round(amount * rate);
    return { base: amount, rate, gst, total: amount + gst };
}
